export const getPosthogUrlForUser = (
  projectId: string,
  userId: string,
): string => {
  return `https://us.posthog.com/project/${projectId}/person/${userId}#activeTab=events`;
};
